import { render, staticRenderFns } from "./safe-index.vue?vue&type=template&id=76e0cd4f&"
import script from "./safe-index.vue?vue&type=script&lang=js&"
export * from "./safe-index.vue?vue&type=script&lang=js&"
import style0 from "./safe-index.vue?vue&type=style&index=0&id=76e0cd4f&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports